import { render } from "./MainAccess.vue?vue&type=template&id=3fb5cf6e&scoped=true"
import script from "./MainAccess.vue?vue&type=script&lang=js"
export * from "./MainAccess.vue?vue&type=script&lang=js"

import "./MainAccess.vue?vue&type=style&index=0&id=3fb5cf6e&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb5cf6e"]])

export default __exports__